export const isRefundPassenger = (passenger) => !('values' in passenger);
